(() => {
  if (window.FreeShippingCounter?.__loaded) return;

  const REGION_BY_UF = {
    PR:"sul", RS:"sul", SC:"sul",
    ES:"sudeste", MG:"sudeste", RJ:"sudeste", SP:"sudeste",
    DF:"centro_oeste", GO:"centro_oeste", MT:"centro_oeste", MS:"centro_oeste",
    AL:"nordeste", BA:"nordeste", CE:"nordeste", MA:"nordeste", PB:"nordeste",
    PE:"nordeste", PI:"nordeste", RN:"nordeste", SE:"nordeste",
    AC:"norte", AM:"norte", AP:"norte", PA:"norte", RO:"norte", RR:"norte", TO:"norte"
  };

  const state = {
    ufPromise: null,
    cartFetchAbort: null,
    refreshTimer: null,
    refreshSeq: 0 // ✅ CONTROLE DE ORDEM (FIX)
  };

  function $(sel, root=document) { return root.querySelector(sel); }
  function $all(sel, root=document) { return Array.from(root.querySelectorAll(sel)); }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function toCents(value) {
    const n = Number(String(value || "0").replace(",", "."));
    if (Number.isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function formatMoneyBRL(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.__fsMoneyFormat || null);
    }
    return (cents / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  }

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, s => ({
      "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
    }[s]));
  }

  async function getUF() {
    const key = "fs_geo_v2";
    try {
      const cached = JSON.parse(localStorage.getItem(key) || "null");
      if (cached && ("uf" in cached) && cached.exp && Date.now() < cached.exp) {
        return cached.uf;
      }
    } catch(e) {}

    try {
      const res = await fetch(
        "https://ipwho.is/?fields=success,country_code,region_code",
        { method:"GET", mode:"cors" }
      );
      const data = await res.json();
      const uf = (data && data.success === true && data.country_code === "BR" && data.region_code)
        ? String(data.region_code).toUpperCase()
        : null;

      try {
        localStorage.setItem(key, JSON.stringify({
          uf,
          exp: Date.now() + 24*60*60*1000
        }));
      } catch(e) {}

      return uf;
    } catch(e) {
      try {
        localStorage.setItem(key, JSON.stringify({
          uf: null,
          exp: Date.now() + 6*60*60*1000
        }));
      } catch(_) {}
      return null;
    }
  }

  function getThresholdCents(el, uf) {
    const thresholds = {
      default: toCents(el.dataset.defaultThresholdReais),
      sudeste: toCents(el.dataset.sudesteThresholdReais),
      sul: toCents(el.dataset.sulThresholdReais),
      centro_oeste: toCents(el.dataset.centro_oesteThresholdReais),
      nordeste: toCents(el.dataset.nordesteThresholdReais),
      norte: toCents(el.dataset.norteThresholdReais),
    };

    if (!uf) return thresholds.default || 0;
    const region = REGION_BY_UF[uf];
    if (!region) return thresholds.default || 0;

    return thresholds[region] || 0;
  }

  async function getCartTotalCents() {
    if (state.cartFetchAbort) state.cartFetchAbort.abort();
    state.cartFetchAbort = new AbortController();

    const rootPath = (window.Shopify?.routes?.root)
      ? window.Shopify.routes.root
      : "/";

    const res = await fetch(`${rootPath}cart.js`, {
      credentials: "same-origin",
      signal: state.cartFetchAbort.signal
    });

    const cart = await res.json();
    return Number(cart.total_price || 0);
  }

  function render(el, totalCents, thresholdCents) {
    if (!thresholdCents || thresholdCents <= 0) {
      el.style.display = "none";
      el.classList.remove("is-ready");
      return;
    }

    el.style.display = "";
    el.classList.add("is-ready");

    const remaining = Math.max(0, thresholdCents - totalCents);
    const progress = clamp((totalCents / thresholdCents) * 100, 0, 100);

    const progressEl = $(".js-progress", el);
    const msgWrap = $(".cart__free-shipping-counter__msg", el);

    if (progressEl) {
      progressEl.style.width = `${progress.toFixed(2)}%`;
    }

    if (!msgWrap) return;

    const successText = el.dataset.successText || "Você já tem frete grátis!";
    const almostText = el.dataset.almostText || "Quase lá, adicione";
    const almostText2 = el.dataset.almostText2 || "mais para obter";
    const freeLabel = el.dataset.freeLabel || "FRETE GRÁTIS";

    if (remaining <= 0) {
      msgWrap.innerHTML = `<p><strong>${escapeHtml(successText)}</strong></p>`;
    } else {
      msgWrap.innerHTML = `
        <p>
          ${escapeHtml(almostText)}
          <strong>${formatMoneyBRL(remaining)}</strong>
          ${escapeHtml(almostText2)}
          <strong>${escapeHtml(freeLabel)}</strong>!
        </p>
      `;
    }
  }

  async function refreshNow() {
    const seq = ++state.refreshSeq; // ✅ FIX

    const counters = $all("[data-fs-counter]");
    if (!counters.length) return;

    if (!state.ufPromise) state.ufPromise = getUF();
    const uf = await state.ufPromise;

    let total = 0;
    try {
      total = await getCartTotalCents();
    } catch(e) {
      return;
    }

    // ✅ impede render de fetch antigo
    if (seq !== state.refreshSeq) return;

    counters.forEach(el => {
      const threshold = getThresholdCents(el, uf);

      const color = el.dataset.progressColor || "#50aa6c";
      const fill = $(".js-progress", el);
      if (fill) fill.style.backgroundColor = color;

      render(el, total, threshold);
    });
  }

  function scheduleRefresh() {
    clearTimeout(state.refreshTimer);
    state.refreshTimer = setTimeout(refreshNow, 120);
  }

  ["cart:updated","cart:refresh","cart:change","cart-drawer:open","drawer:open"]
    .forEach(evt => {
      document.addEventListener(evt, scheduleRefresh);
    });

  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
      if (url && /\/cart\/(add|change|update|clear)\.js|\/cart\.js/.test(url)) {
        scheduleRefresh();
      }
    } catch(_) {}
    return res;
  };

  const obs = new MutationObserver(scheduleRefresh);
  obs.observe(document.documentElement, { childList:true, subtree:true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRefresh);
  } else {
    scheduleRefresh();
  }

  window.FreeShippingCounter = {
    __loaded: true,
    refresh: scheduleRefresh
  };
})();
